import { InfoIcon } from "lucide-react";

import { BasicTooltip } from "../../code-editor/BasicTooltip";

import { OpenaiYamlToolDependencyFieldInput } from "./ToolDependencyFieldInput";
import type { ToolDependency, ToolDependencyFormField } from "./types";

const LABEL_ROW_HEIGHT_CLASS = "h-[20px]";

export interface OpenaiYamlToolDependencyFormFieldCellProps {
  field: ToolDependencyFormField;
  panelId: string;
  tool: ToolDependency;
  index: number;
  readOnly?: boolean;
  onUpdate: (index: number, patch: Partial<ToolDependency>) => void;
}

export const OpenaiYamlToolDependencyFormFieldCell = ({
  field,
  panelId,
  tool,
  index,
  readOnly = false,
  onUpdate,
}: OpenaiYamlToolDependencyFormFieldCellProps) => {
  const inputId = `${panelId}-${field.key}`;

  return (
    <div className="space-y-1">
      {field.tooltip ? (
        <div className={`flex ${LABEL_ROW_HEIGHT_CLASS} items-center gap-1`}>
          <label htmlFor={inputId} className="text-xs text-gray-500">
            {field.label}
          </label>
          <BasicTooltip content={field.tooltip}>
            <InfoIcon className="h-3.5 w-3.5 cursor-pointer text-gray-400 hover:text-gray-600" />
          </BasicTooltip>
        </div>
      ) : (
        <label htmlFor={inputId} className="text-xs text-gray-500">
          {field.label}
        </label>
      )}
      <OpenaiYamlToolDependencyFieldInput
        field={field}
        inputId={inputId}
        value={tool[field.key]}
        readOnly={readOnly}
        onValueChange={next => onUpdate(index, { [field.key]: next })}
      />
    </div>
  );
};
